import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import NewTimetable from "./NewTimetable";
import TimetableDetail from "./TimetableDetail";
import { ReadData } from "../../../../providers/Patient.Provider";
import TimetableList from "./TimetableList";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { LIST, CREATE } from "../../../../queries/timetable.query";
import LoadingSpinner from "../../../../partials/loading";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../../util/app";
import { EventEmitter } from "../../../../event/EventEmitter";
import { EVENT_TARGET, ACTION_TYPE } from "../../../../event/model";
import { sendNotification } from "../../../../sockette";

const Timetable = () => {
    const [newTimetable, setNewTimetable] = useState(false);
    const [timetable, setTimetable] = useState(null);
    const patient = ReadData();

    // query
    const { loading, data, refetch } = useQuery(LIST, {
        variables: { id: patient.lastAdmission },
        onError: (e) => toast.error(CleanMessage(e.message)),
        notifyOnNetworkStatusChange: true,
    });

    // Mutation
    const [CreateFunc, { loading: cLoading }] = useMutation(CREATE, {
        onCompleted: (d) => {
            if (d.StartNewTimetable) {
                const { message } = d.StartNewTimetable;
                toast.success(message);
                sendNotification(message, ACTION_TYPE.CREATE, EVENT_TARGET.TIMETABLE);
            }
            setTimeout(() => {
                setNewTimetable(false);
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }, 1000);
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    if (patient && !patient.lastAdmission)
        return (
            <>
                <Helmet>
                    <title>Patient Timetable | {appName}</title>
                </Helmet>

                <div className="text-center">
                    <h2 className="text-pink">Feature can only be used for in-patient only!</h2>
                </div>
            </>
        );

    EventEmitter.subscribe(EVENT_TARGET.TIMETABLE, () => refetch());

    return (
        <>
            <Helmet>
                <title>Patient Timetable | {appName}</title>
            </Helmet>
            <div className="row justify-content-center">
                {newTimetable && !timetable && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>New Timetable</header>
                            </div>
                            <div className="card-body m-b-20">
                                <LoadingSpinner loading={cLoading} />
                                <NewTimetable
                                    onCancel={() => setNewTimetable(false)}
                                    onSubmit={async (item) => {
                                        await CreateFunc({
                                            variables: {
                                                model: {
                                                    ...item,
                                                    admission: patient.lastAdmission,
                                                },
                                            },
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {!timetable && !newTimetable && (
                    <div className="col-md-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>Patient Timetable</header>

                                <div className="float-right mt-2 mr-2">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setNewTimetable(true);
                                            document.body.scrollTop = 0;
                                            document.documentElement.scrollTop = 0;
                                        }}
                                        data-toggle="tab"
                                        className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success"
                                    >
                                        <i className="material-icons"> add</i> New
                                    </button>
                                </div>
                            </div>
                            <div className="card-body m-b-20" style={{ minHeight: "450px" }}>
                                <LoadingSpinner loading={loading} />
                                {!loading && data && <TimetableList items={data && data.GetTimetables.docs} onView={(item) => setTimetable(item)} />}
                            </div>
                        </div>
                    </div>
                )}
                {timetable && !newTimetable && (
                    <div className="row fade-in">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <button onClick={() => setTimetable(null)} className="mdl-button mdl-js-ripple-effect btn-circle margin-right-10">
                                        <i className="material-icons">keyboard_arrow_left</i> Back
                                    </button>
                                    Timetable Detail
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <TimetableDetail onNewNote={() => {}} item={timetable} />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Timetable;
